import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2631_9127)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.60028 8.5H10.4003V12.9L5.60028 16.5V8.5ZM7.20028 10.1V13.3L8.80028 12.1V10.1H7.20028Z"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.893541 1.07903C1.15331 0.656467 1.60626 0.5 2.00006 0.5H14.0321C14.4113 0.5 14.9118 0.637036 15.1717 1.11735C15.4288 1.59264 15.2756 2.08327 15.0768 2.39864L15.0731 2.40453L10.2693 9.73834L8.93085 8.86166L13.3599 2.1H2.64024L7.06928 8.86166L5.73085 9.73834L0.912843 2.38287L0.89716 2.35401C0.701198 1.99345 0.628673 1.50988 0.893541 1.07903Z"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2631_9127",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
